module.exports = __webpack_public_path__ + "/login_ui/img/ro-493e60b23af504d525f06ca826dd6584.svg";